import { render, staticRenderFns } from "./TrialsView.vue?vue&type=template&id=48b3ffce"
import script from "./TrialsView.js?vue&type=script&lang=js&external"
export * from "./TrialsView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports